import ApiService from '../../Services/ApiService';
import { getRequest } from '../../Services/HttpService';

export const RESET_PASSWORD_ERROR = '[AUTH] RESET_PASSWORD_ERROR';
export const RESET_PASSWORD_SUCCESS = '[AUTH] RESET_PASSWORD_SUCCESS';

const ResetPasswordService = {
  async getForm(token: string | undefined, language: string): Promise<any> {
    if (!token) {
      console.warn('Reset  password token is empty.');
      return null;
    }

    const response = await getRequest(`/v1/auth/reset-password/${token}?language=${language}`, {
      noAuthHeader: true,
      returnAxioErrorResponseData: true,
      showErrorToaster: false,
      showToaster: false,
    });

    if (response) {
      return response;
    }
    return false;
  },

  async submitForm(token: string, password: string, confirmPassword: string): Promise<any> {
    const response = await ApiService.post(`/v1/auth/reset-password/${token}`, {
      password,
      confirm_password: confirmPassword,
      language: localStorage.getItem('language'),
    });
    if (response && response.data) {
      return response.data;
    }
    return null;
  },
};

export default ResetPasswordService;
